import { Box } from "@mui/material";
import { Form, Field } from "react-final-form";
import Button from "../../../components/Button";
import { InputText } from "../../../components/Input";
import { SaveNuevoMotivoAjuste } from "../../../services/stockServices";
import { required } from "../../../utils/validations";

const FormAgregarNuevoMotivoAjuste = ({ setAlertCustom, refetch }) => {
  const obj: any = {};
  return (
    <Form
      onSubmit={(values) => {
        SaveNuevoMotivoAjuste({
          ...values,
        })
          .then(() => {
            setAlertCustom({
              open: true,
              title: "Confirmacion",
              severity: "success",
              message: "Se guardo correctamente",
            });
            obj.funcion();
            refetch();
          })
          .catch((error) => {
            setAlertCustom({
              open: true,
              title: "Error",
              severity: "error",
              message: error?.message,
            });
          });
      }}
      initialValues={{}}
      render={({
        handleSubmit,
        form: { restart },
        submitting,
        pristine,
        values,
      }) => {
        obj.funcion = restart;
        return (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <Box className="col-12">
              <Field
                validate={required}
                component={InputText as any}
                name={"stock_motivo_ajuste_descripcion"}
                label={"descripcion motivo"}
                sx={{ width: "100%" }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 3,
              }}
              className="col-12"
            >
              <Button
                label={"Agregar"}
                onClick={handleSubmit}
                sx={{ minWidth: "150px" }}
                color="success"
              />
            </Box>
          </Box>
        );
      }}
    />
  );
};
export default FormAgregarNuevoMotivoAjuste;
